<template>
  <v-container fill-height>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left>
              insert_chart
            </v-icon>
            <span class="title">Dashboard</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="3">
                <v-card>
                  <v-card-text>
                    <v-select
                      :items="listyears"
                      name="filteryear"
                      v-model="filter.year"
                      label="Tahun">
                    </v-select>
                  </v-card-text>
                  <v-card-actions class="justify-center">
                    <div class="text-center" v-if="loading.changedb">
                      <v-progress-circular
                        :width="3"
                        color="red"
                        indeterminate>
                      </v-progress-circular>
                    </div>
                    <v-btn v-if="!loading.changedb" block color="warning" dark @click="updateChart">Ubah</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="3">
                <v-card
                  class="mx-auto text-center"
                  color="red"
                  dark>
                  <v-card-text>
                    <v-icon size="50" dark>mdi-email-check</v-icon>
                  </v-card-text>
                  <v-card-text>
                    <div class="display-1">
                      {{ datacard.sk }}
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-center">
                    <v-btn
                      block
                      text
                      :to="{ name: 'SKDosen' }">
                      Surat Keputusan <v-icon right>arrow_forward</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="3">
                <v-card
                  class="mx-auto text-center"
                  color="green"
                  dark>
                  <v-card-text>
                    <v-icon size="50" dark>mdi-email-arrow-right</v-icon>
                  </v-card-text>
                  <v-card-text>
                    <div class="display-1">
                      {{ datacard.st }}
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-center">
                    <v-btn
                      block
                      text
                      :to="{ name: 'STDosen' }">
                      Surat Tugas <v-icon right>arrow_forward</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="3">
                <v-card
                  class="mx-auto text-center"
                  color="primary"
                  dark>
                  <v-card-text>
                    <v-icon size="50" dark>mdi-email-sync</v-icon>
                  </v-card-text>
                  <v-card-text>
                    <div class="display-1">
                      {{ datacard.lain }}
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-center">
                    <v-btn
                      block
                      text
                      :to="{ name: 'SLDosen' }">
                      Surat Lainnya <v-icon right>arrow_forward</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import qs from 'qs';
import { mapState } from 'vuex';
import firebase from 'firebase/app';
import 'firebase/messaging';

export default {
  name: 'Home',
  data: () => ({
    api: process.env.VUE_APP_API,
    modulklian: process.env.VUE_APP_MOD_KLIAN,
    loading: {
      changedb: false,
    },
    filter: {
      year: new Date().getFullYear(),
    },
    datacard: {
      siap: 0,
      batal: 0,
      selesai: 0,
      proses: 0,
      permohonan: 0,
    },
    btnto: 'SuratGuest',
    btnto2: 'SuratGuest',
    btnto3: 'SuratGuest',
    btnto4: 'SuratGuest',
  }),
  created() {
    try {
      firebase
        .messaging()
        .requestPermission()
        .then(() => {
          console.log('Notification permission granted');
          firebase
            .messaging()
            .getToken()
            .then((token) => {
              this.updateToken(token);
              // this.receiveMessage();
            });
        })
        .catch((err) => {
          console.log('Unable to get token ', err);
        });
    } catch (e) {
      console.log(e);
    }
  },
  mounted() {
    // console.log(this.fbtoken);
    // title
    this.$store.commit('UPDATE_TITLE', 'Home');
    // for btn detail
    if (this.userrole === 'admin') {
      this.btnto = 'SuratAdmin';
      this.btnto2 = 'SuratAdmin';
      this.btnto3 = 'SuratAdmin';
      this.btnto4 = 'SuratAdmin';
    } else if (this.userrole === 'dosen') {
      this.btnto = 'SuratketeranganDosen';
      this.btnto2 = 'SurattugasDosen';
      this.btnto3 = 'SuratlainDosen';
      this.btnto4 = 'NosuratDosen';
    } else {
      this.btnto = 'SuratGuest';
      this.btnto2 = 'SuratGuest';
      this.btnto3 = 'SuratGuest';
      this.btnto4 = 'SuratGuest';
    }
    // init request
    if (this.tokenscr) {
      this.updateChart();
    }
  },
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'usernik',
      'fbtoken',
    ]),
    listyears() {
      const year = new Date().getFullYear();
      const lyear = Array.from({length: year - 2020}, (value, index) => 2021 + index);
      lyear.push('all');
      return lyear;
    },
  },
  methods: {
    receiveMessage() {
      try {
        firebase.messaging().onMessage((payload) => {
          console.log('payload ', payload);
        });
      } catch (e) {
        console.log(e);
      }
    },
    updateToken(token) {
      // window.console.log('token ', token);
      // update token
      if (this.tokenscr) {
        this.axios
          .post(
            this.api + '/api/fb/token',
            qs.stringify(
              {
                tkn: token,
              },
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                // update token id
                this.$store.commit('FB_UTOKEN', resdata.data);
              } else {
                console.log(resdata.message);
              }
            } else {
              console.log('Internal services error!');
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    resetDataCard() {
      this.datacard = {
        sk: 0,
        st: 0,
        lain: 0,
        no: 0,
      };
    },
    updateChart() {
      this.resetDataCard();
      if (this.tokenscr) {
        this.loading.changedb = true;
        this.axios
          .get(
            this.api + '/api/user/dashboard/eoffice/' + this.filter.year,
            {
              params: {},
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datacard = resdata.data;
              }
              // console.log(this.datacard);
            }
            this.loading.changedb = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.changedb = false;
          });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
